import { Box } from "@mui/material"
import { Links } from "routes/shared-with-me/links"
import { HelpTag } from "routes/help/helpTag"
import { PageBreadcrumbContainer } from "lib/page-breadcrumb-container"
import { HELPTAG_SHARED_WITH_ME } from "routes/help/help-tag-constants"

export function SharedWithMe() {
    return (
        <PageBreadcrumbContainer title="Shared With Me">
            <HelpTag tags={[HELPTAG_SHARED_WITH_ME]} />
            <Box flex={1} sx={{ overflowY: "scroll" }} p={1}>
                <Links />
            </Box>
        </PageBreadcrumbContainer>
    )
}
